import { combineReducers } from "redux";
import indices from "./indices";
import advanceDecline from "./advanceDecline";
import recommendations from "./recommendation";
import marketToday from "./marketToday";
import drivingMarket from "./Driving Market/drivingMarketReducers";
import ipoReducer from "./ipoReducer";
import insiderMainReducer from "./insiderTradingSast/insiderMainReducers";
import sectorPerformance from "./sectorPerformance";
import marketMap from "./MarketMap/marketMaps";
import marketNewsReducer from "./marketNews";
import fiiDii from "./FiiDii/fiiDii";
import stockSurveillanceReducer from "./stockSurveillance";
import indicesViewAll from "./indicesViewAll";
import advanceDeclineViewAll from "./advanceDeclineViewAll";
export default combineReducers({
    indices: indices,
    advanceDecline: advanceDecline,
    marketToday: marketToday,
    recommendations: recommendations,
    ipoReducer: ipoReducer,
    insiderMainReducer: insiderMainReducer,
    drivingMarket: drivingMarket,
    sectorPerformance: sectorPerformance,
    marketMap: marketMap,
    marketNewsReducer: marketNewsReducer,
    fiiDii: fiiDii,
    stockSurveillanceReducer: stockSurveillanceReducer,
    indicesViewAll: indicesViewAll,
    advanceDeclineViewAll: advanceDeclineViewAll,
});
